define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/Logger',
	'model/ErrorType',
	'model/Attribute',
	'state/UIState',
	'service/UIStateManager',
	'view/ProviderInfoView',
	'view/NavigationView',
	'identity/IdentityDecryptView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/IdentityTransferState_strings'
], function (
	Util,
	UiUtil,
	Logger,
	ErrorType,
	Attribute,
	UIState,
	UIStateManager,
	ProviderInfoView,
	NavigationView,
	IdentityDecryptView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * IdentityTransferState class
	 */
	function IdentityTransferState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_identityDecryptView = new IdentityDecryptView(getCloudIdentity),
			_controlBarView = new ControlBarView('skIdS_control-bar-identity-transfer'),
			_backButton,
			_transferCloudIDURL = null,
			_transferStarted = false,
			_salt = null;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.insert_pin);

		_identityDecryptView.get().addClass('skIdS_content-body');

		_backButton = _controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.back();
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		window.addEventListener('resize', function () {
			UiUtil.scrollTo(_navigationView.get());
		});

		UIState.call(this, 'identity_transfer');


		// private methods

		function getCloudIdentity(secret) {
			var cloudIdentitiesManager = _uiStateManager.core().cloudIdentitiesManager();

			if (_transferStarted) {
				return;
			}

			_transferStarted = true;

			_identityDecryptView.showLoadingIndicator();

			if (!Util.isValidURL(_transferCloudIDURL)) {
				_transferCloudIDURL = cloudIdentitiesManager.getCloudIdentityTransferURL(_transferCloudIDURL);
			}

			cloudIdentitiesManager.collectCloudIdentity(_transferCloudIDURL, _salt, function (identity, doneCallbacks) {
				_transferStarted = false;

				_identityDecryptView.hideLoadingIndicator();

				Util.callCallbacks(doneCallbacks);

				_uiStateManager.change('identity_management', { identity : identity, secret : secret });
			}, function (error) {
				_identityDecryptView.hideLoadingIndicator();

//				if (error.type() === ErrorType.RECOVERABLE && error.data() !== -1) {
//					_transferStarted = false;
//
//					_identityDecryptView.update();
//					_identityDecryptView.showError(error.data());
//				} else {
					_uiStateManager.change('error', {
						error : error,
						nextCallback : function () {
							_uiStateManager.change('identities_overview');
						}
					});
//				}
			});
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _identityDecryptView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, transferData) {
			_transferCloudIDURL = transferData['transferURL'];
			_salt = transferData['salt'];

//			_providerInfoView.update(_uiStateManager.core().cloudIdentitiesManager().providerInfo());

//			_identityDecryptView.update();

			if (_uiStateManager.core().parameters().hasOwnProperty('trans')) {
				_backButton.hide();
			} else {
				_backButton.show();
			}

//			Util.callCallbacks(doneCallback);

//			UiUtil.scrollTo(_navigationView);

			getCloudIdentity(null);
			
			Util.callCallbacks(doneCallback);
		};

		this.leave = function (doneCallback) {
			_transferCloudIDURL = null;
			_transferStarted = false;

			Util.callCallbacks(doneCallback);
		};
	};

	IdentityTransferState.prototype = Object.create(UIState.prototype);

	return IdentityTransferState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/IdentityTransferState.js
// module id = 327
// module chunks = 2